import request from '@/request'

export const partyinfoList = (data) => {
  return request({
    url: '/mobile_PartyInfo/list.action',
    method: 'post',
    data,
    secret: false
  })
}

export const getAccountinfo = (data) => {
  return request({
    url: '/inf_Credit/getAccountinfo.action',
    method: 'post',
    data,
    secret: false,
    isMd5: false
  })
}
export const operateCredit = (data) => {
  return request({
    url: '/inf_Credit_Vipwd/operateCredit.action',
    method: 'post',
    data
  })
}

export const getAllPerInfo = (data) => {
  return request({
    url: '/inf_bankaccInfo/getAllPerInfo.action',
    method: 'post',
    data
  })
}
export const getList = (data) => {
  return request({
    url: '/inf_WXArticles_Vipwd/getList.action',
    method: 'post',
    data,
    isMd5: true
  })
}
export const getUserCreditRule = (data) => {
  return request({
    url: '/inf_Credit_Vipwd/getUserCreditRule.action',
    method: 'post',
    data
  })
}
export const getSignlist = (data) => {
  return request({
    url: '/inf_Credit_Vipwd/getSignlist.action',
    method: 'post',
    data
  })
}
export const getRuleList = (data) => {
  return request({
    url: '/inf_Credit/getRuleList.action',
    method: 'post',
    data,
    secret: false,
    isMd5: true
  })
}

export const getProdList = (data) => {
  return request({
    url: '/integral_prod/list.action',
    method: 'post',
    data,
    isMd5: true
  })
}
export const getProdView = (data) => {
  return request({
    url: '/integral_prod/view.action',
    method: 'post',
    data,
    isMd5: true
  })
}
export const getAddressList = (data) => {
  return request({
    url: '/integral_address/list.action',
    method: 'post',
    data,
    isMd5: true
  })
}

export const getDetailList = (data) => {
  return request({
    url: '/inf_Credit/getDetailList.action',
    method: 'post',
    data,
    secret: false,
    isMd5: true
  })
}
export const addorder = (data) => {
  return request({
    url: '/integral_order/addorder.action',
    method: 'post',
    data,
    isMd5: true
  })
}

export const getDefaultAddress = (data) => {
  return request({
    url: '/integral_address/getdefault.action',
    method: 'post',
    data,
    isMd5: true
  })
}

export const addAddress = (data) => {
  return request({
    url: '/integral_address/add.action',
    method: 'post',
    data,
    isMd5: true
  })
}

export const editAddress = (data) => {
  return request({
    url: '/integral_address/edit.action',
    method: 'post',
    data,
    isMd5: true

  })
}
export const deleteAddress = (data) => {
  return request({
    url: '/integral_address/delete.action',
    method: 'post',
    data,
    isMd5: true

  })
}
export const getOrderList = (data) => {
  return request({
    url: '/integral_order/orderlist.action',
    method: 'post',
    data,
    isMd5: true
  })
}
export const getOrderView = (data) => {
  return request({
    url: '/integral_order/orderview.action',
    method: 'post',
    data,
    isMd5: true
  })
}
// 新增记录
export const getaddlog = data => {
  return request({
    url: '/mobile_Page_Vipwd/addClickLog.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}